<template>
  <div>
    <div class="row">
      <div class="col-6">
        <h5>Feature Settings for: {{ site.name }}</h5>
        <router-link :to="{ name: 'AdminSiteIndex' }" class="btn btn-light">
          <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>Back
        </router-link>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-8">
        <form>
          <div
            v-for="phoenix_setting in filtered_phoenix_settings"
            :key="phoenix_setting.phoenix_setting_id"
          >
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.INTERCOM' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Intercom</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.BELL' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Bell</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.MULTICAST' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Multicast</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.DEVICE.RTP' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Allow RTP Devices</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.DEVICE.SIP' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Allow SIP Devices</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.DEVICE.BARIONET' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Allow Barionet Devices</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SMS' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">SMS</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SMS' && phoenix_setting.setting === 'MAX_PHONE_NUMBERS'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">SMS - Max Phone Numbers</label>
                <div class="col-sm-12 col-lg-6">
                  <input
                    class="form-control"
                    type="number"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SIGNALWIRE' && phoenix_setting.setting === 'VOIP_PHONE_NUMBER'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Signalwire VoIP Phone Number</label>
                <div class="col-sm-12 col-lg-6">
                  <vue-tel-input
                    :onlyCountries="['US']"
                    :validCharactersOnly="true"
                    @input="updateVoipPhone"
                    v-model="phoenix_setting.value"
                  ></vue-tel-input>
                </div>
              </div>
            </div>
           <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SIGNALWIRE' && phoenix_setting.setting === 'SMS_PHONE_NUMBER'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Signalwire SMS Phone Number</label>
                <div class="col-sm-12 col-lg-6">
                  <vue-tel-input
                    :onlyCountries="['US']"
                    :validCharactersOnly="true"
                    @input="updateSmsPhone"
                    v-model="phoenix_setting.value"
                  ></vue-tel-input>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SIGNALWIRE' && phoenix_setting.setting === 'SPACE_URL'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Signalwire Space URL</label>
                <div class="col-sm-12 col-lg-6">
                  <input
                    class="form-control"
                    type="text"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SIGNALWIRE' && phoenix_setting.setting === 'PROJECT_ID'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Signalwire Project ID</label>
                <div class="col-sm-12 col-lg-6">
                  <input
                    class="form-control"
                    type="text"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SIGNALWIRE' && phoenix_setting.setting === 'API_TOKEN'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Signalwire API Token</label>
                <div class="col-sm-12 col-lg-6">
                  <input
                    class="form-control"
                    type="text"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.DAILY_DEVICE_REPORT' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Daily Device Report</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.DAILY_DEVICE_REPORT' && phoenix_setting.setting === 'TIME'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Daily Device Report - Time</label>
                <div class="col-sm-12 col-lg-6">
                  <input
                    type="text"
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  />
                  <small
                    class="form-text text-muted"
                  >Must be of the the format hh:mm:ss, no am or pm. Example: 05:00:00 or 16:30:00</small>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.EMAIL' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Email</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.VOIP' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">VoIP</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.DEVICE_REGISTRATION_NOTIFICATION' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Device Registration Notification</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.VISUAL_ALERT' && phoenix_setting.setting === 'ENABLED'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-lg-4 col-form-label">Visual Alert</label>
                <div class="col-sm-12 col-lg-6">
                  <select
                    class="form-control"
                    @change="editPhoenixSetting(phoenix_setting)"
                    v-model="phoenix_setting.value"
                  >
                    <option value="1">On</option>
                    <option value="0">Off</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  props: ['site_id'],
  computed: {
    ...mapGetters({
      site: 'singleSite',
      phoenix_settings: 'allPhoenixSettings'
    }),
    filtered_phoenix_settings: function () {
      return this.phoenix_settings.filter(ps => ps.site_id === this.site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')
    this.$store.dispatch('getSite', this.site_id)
  },
  methods: {
    ...mapActions(['editPhoenixSetting']),
    updateVoipPhone (num, data) {
      if (data.isValid || _.isEmpty(data.number)) {
        let phoenixSetting = this.filtered_phoenix_settings.filter(
          ps =>
            ps.domain === 'PHOENIX.FEATURE.SIGNALWIRE' &&
            ps.setting === 'VOIP_PHONE_NUMBER'
        )[0]
        this.$store.dispatch('editPhoenixSetting', {
          phoenix_setting_id: phoenixSetting.phoenix_setting_id,
          value: data.number.replace(/\s/g, '')
        })
      }
    },
    updateSmsPhone (num, data) {
      if (data.isValid || _.isEmpty(data.number)) {
        let phoenixSetting = this.filtered_phoenix_settings.filter(
          ps =>
            ps.domain === 'PHOENIX.FEATURE.SIGNALWIRE' &&
            ps.setting === 'SMS_PHONE_NUMBER'
        )[0]
        this.$store.dispatch('editPhoenixSetting', {
          phoenix_setting_id: phoenixSetting.phoenix_setting_id,
          value: data.number.replace(/\s/g, '')
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
